import { Col, Form, Modal, notification, Row, Space } from 'antd';
import classNames from 'classnames';
import classnames from 'classnames';
import { memo, useCallback, useEffect, useState } from 'react';
import { Controller, useFieldArray, useForm, useWatch } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';

import FormItemWrap from '@/components/FormItemWrap';
import InputOnlyNumber from '@/components/InputOnlyNumber';
import InputWrap from '@/components/InputWrap';
import ModalWrap from '@/components/ModalWrap';
import RadioWrap from '@/components/RadioWrap';
import SelectWrap from '@/components/SelectWrap';
import { pattern } from '@/constants/validate';
import floorService from '@/services/floor.service';
import RoomTypeService from '@/services/room-type.service';
import roomService from '@/services/room.service';
import { convertLetterToNumber } from '@/util/convertLetterToNumber';
import './style.scss';
import { handleMessageError } from '@/util/handleMessageError';
import { RequestRoomDTO } from '@/dto/responseDto/request-room.dto';
import { ResponseRoomTypeDTO } from '@/dto/responseDto/room-type.dto';

interface IProps {
    storeId?: string;
}

const Content: React.FC<IProps> = () => {
    const yesNoOptions = [
        {
            value: 'Không',
            id: 0,
        },
        {
            value: 'Có',
            id: 1,
        },
    ];

    const [isOpenModal, setOpenModal] = useState<boolean>(false);
    const [form] = Form.useForm();
    const {
        control,
        reset,
        getValues,
        setValue,
        formState: { errors },
        handleSubmit,
    } = useForm();

    const handleModal = (positionX?: number, positionY?: number, room?: any, floor?: number) => {
        const aph = Number(positionY) + 1;
        const convert = String.fromCharCode(aph + 64);
        const floorPosition = `${convert}-${Number(positionX) + 1}`;

        if (room?._id) {
            reset({
                ...room,
                floor: room?.floor?._id,
                roomType: room?.roomType?._id,
                baotri: room?.baotri ? 1 : 0,
            });
        } else {
            reset({
                roomType: null,
                roomNo: null,
                floor,
                floorPosition,
                baotri: 0,
            });
        }

        setOpenModal(true);
    };

    const cancelModal = () => {
        reset();
        setOpenModal(false);
    };

    const [floorId, setFloorId] = useState<string>('');

    const positionString = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];

    const { data: roomData, refetch } = useQuery(['room', floorId], () => roomService.getAll({ floorId }), {
        enabled: !!floorId,
        cacheTime: 0,
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const { data: roomTypeData } = useQuery(['room-type'], () => RoomTypeService.getAll(), {
        enabled: true,
        onSuccess: (data) => {
            if (data?.data?.length === 0) {
                notification.error({
                    message: 'CHƯA TẠO KIỂU PHÒNG',
                });
            }
        },
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const { data: floorData } = useQuery(['floor'], () => floorService.getAll(), {
        enabled: true,
        onSuccess: (data) => {
            if (data?.data?.length) {
                setFloorId(data.data[0]._id);
            } else {
                notification.error({
                    message: 'CHƯA TẠO TẦNG',
                });
            }
        },
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const headerRoom = () => {
        return positionString.map((name, index) => (
            <div key={index} className={classNames('status__seat', 'head')}>
                <span> {name}</span>
            </div>
        ));
    };

    const rowRoom = (item: any[], positionX: number) => {
        return (
            item.length &&
            item.map((room, index) => (
                <div
                    onClick={() => handleModal(positionX, index, room, Number(floorId))}
                    key={index}
                    style={{ backgroundColor: room && room.roomType?.bgColor }}
                    className={classNames('status__seat', 'change_phong')}
                >
                    <span className={classnames({ isRoom: room })}> {room ? room.roomNo : '-'}</span>
                </div>
            ))
        );
    };

    const { mutate: mutateCreate } = useMutation((body: RequestRoomDTO) => roomService.createAdmin(body), {
        onSuccess: (data: any) => {
            notification.success({
                message: 'TẠO PHÒNG THÀNH CÔNG',
            });
            setOpenModal(false);
            refetch();
        },
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const { mutate: mutateUpdate } = useMutation((body: RequestRoomDTO) => roomService.update(body._id, body), {
        onSuccess: (data: any) => {
            notification.success({
                message: 'CẬP NHẬT PHÒNG THÀNH CÔNG',
            });
            // onGoList();
            setOpenModal(false);
            refetch();
        },
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const { mutate: mutateDelete } = useMutation((id: string | number) => roomService.delete(id), {
        onSuccess: (data: any) => {
            notification.success({
                message: 'XÓA PHÒNG THÀNH CÔNG',
            });
            refetch();
            setOpenModal(false);
        },
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const confirmDelete = useCallback(
        (id: string | number) => {
            Modal.confirm({
                title: 'XÁC NHẬN XÓA PHÒNG',
                content: 'Bạn chắc muốn xóa phòng này không?',
                onOk: () => {
                    mutateDelete(id);
                },
                okText: 'Xóa phòng',
                cancelText: 'Đóng',
            });
        },
        [mutateDelete],
    );

    const ListRoom: any[] = [
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
    ];
    if (roomData && roomData.data && roomData.data.length) {
        roomData.data.forEach((item: any) => {
            const positionY = convertLetterToNumber(item.floorPosition.split('-')[0]) - 1;
            const positionX = Number(item.floorPosition.split('-')[1]) - 1;
            ListRoom[positionX][positionY] = item;
        });
    }
    const roomTypeOptions =
        roomTypeData && roomTypeData.data.map((item: any, index: number) => ({ id: item._id, value: item.name }));

    const onSubmit = (data: any) => {
        const body: RequestRoomDTO = data;
        body.floor = floorId;

        if (data._id) {
            mutateUpdate(body);
        } else {
            mutateCreate(body);
        }
    };

    const onChangeFloor = (data: any) => {
        setFloorId(data._id);
    };

    // const isDisabledLockPC = computers && computers.some((el: any) => el.name === '' || el.ip === '');
    useEffect(() => {
        refetch();
    }, [floorId, refetch]);

    return (
        <>
            {floorData && floorData.data.length > 0 && roomData && roomData.data && (
                <Space direction="vertical" size={32}>
                    <Row gutter={16}>
                        <Col span={24}>
                            <div className="list-floor">
                                {floorData.data.map((item: any, index: number) => (
                                    <div
                                        className={classnames('floor-tab', {
                                            active: item._id === floorId,
                                        })}
                                        onClick={() => onChangeFloor(item)}
                                        key={index}
                                    >
                                        {item.name}
                                    </div>
                                ))}
                            </div>
                        </Col>
                        <Col span={24}>
                            <Row className="list-seat">{headerRoom()}</Row>
                            {ListRoom.map((item, index) => (
                                <Row key={index} className="list-seat">
                                    <div className={classNames('status__seat', 'head')}>
                                        <span> {index + 1}</span>
                                    </div>
                                    {rowRoom(item, index)}
                                </Row>
                            ))}
                        </Col>
                    </Row>
                    <Row justify="end">
                        <Space size={50}>
                            {roomTypeData &&
                                roomTypeData?.data?.map((item: ResponseRoomTypeDTO, index: number) => (
                                    <div className="status__seat" key={index}>
                                        <label htmlFor="">{item.name}:</label>
                                        <span style={{ backgroundColor: item?.bgColor }}></span>
                                    </div>
                                ))}
                        </Space>
                    </Row>
                </Space>
            )}
            <ModalWrap
                className="modal-room"
                width={500}
                title={getValues('_id') ? 'CẬP NHẬT' : 'THÊM MỚI'}
                visible={isOpenModal}
                isBtnDelete={!!getValues('_id')}
                okText={getValues('_id') ? 'CẬP NHẬT' : 'THÊM MỚI'}
                onOk={form.submit}
                onCancel={cancelModal}
                onDelete={() => confirmDelete(getValues('_id'))}
                destroyOnClose={true}
            >
                <div className="form__room">
                    <Form labelCol={{ span: 6 }} form={form} onFinish={handleSubmit(onSubmit)}>
                        <Col span={24}>
                            <FormItemWrap label="Vị trí" colon={false}>
                                <Controller
                                    name="floorPosition"
                                    control={control}
                                    render={({ field }) => <InputWrap disabled field={field} />}
                                />
                            </FormItemWrap>
                            <FormItemWrap label="Số phòng" required validateStatus={errors?.roomNo ? 'error' : ''}>
                                <Controller
                                    name="roomNo"
                                    control={control}
                                    rules={{ required: true, minLength: 1, maxLength: 3, pattern: pattern.inputNumber }}
                                    render={({ field }) => <InputOnlyNumber maxLength={3} field={field} />}
                                />
                            </FormItemWrap>

                            <FormItemWrap
                                required
                                label="Loại phòng"
                                validateStatus={errors?.roomType ? 'error' : ''}
                                colon={false}
                            >
                                <Controller
                                    name="roomType"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => <SelectWrap options={roomTypeOptions} field={field} />}
                                />
                            </FormItemWrap>
                            <FormItemWrap
                                label="Đang bảo trì"
                                validateStatus={errors?.baotri ? 'error' : ''}
                                colon={false}
                            >
                                <Controller
                                    name="baotri"
                                    control={control}
                                    render={({ field }) => <RadioWrap field={field} options={yesNoOptions} />}
                                />
                            </FormItemWrap>
                        </Col>
                    </Form>
                </div>
            </ModalWrap>
        </>
    );
};

export default memo(Content);
